import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './Attitude.module.scss';

const cx = classNames.bind(styles);

const Attitude = ({ roll = 0, pitch = 0, yaw = 0, className }) => {
  const values = useMemo(() => {
    let normalizedYaw = yaw;
    if (normalizedYaw < 0) {
      normalizedYaw += 360;
    }

    return { roll, pitch, yaw: normalizedYaw };
  }, [roll, pitch, yaw]);

  return (
    <div className={cx(['container', className])}>
      <div className={cx('gauges')}>
        <div className={cx(['gauge', 'left'])}>
          <img
            src={require('@/assets/images/attitude/right-background.png')}
            alt=""
            className={cx('background')}
            style={{ transform: `rotate(${-values.roll}deg) translateY(${values.pitch * 1.6}px)` }} // 이미지 위치 보정 상수 1.6
          />
          <img src={require('@/assets/images/attitude/shadow.png')} alt="" className={cx('shadow')} />
          <div className={cx('roll')} />
          <img
            src={require('@/assets/images/attitude/right-coord.png')}
            alt=""
            draggable="false"
            className={cx('coord')}
            style={{ transform: `rotate(${-values.roll}deg)` }}
          />
          <img src={require('@/assets/images/attitude/right-arrow.png')} alt="" draggable="false" />
        </div>
        <div className={cx(['gauge', 'right'])}>
          <img src={require('@/assets/images/attitude/shadow.png')} alt="" className={cx('shadow')} />
          <div className={cx('tics')}>
            {Array.from({ length: 24 }, (_, index) => {
              const option = {};
              if ((index * 15) % 90 === 0) {
                option.big = true;
              } else if ((index * 15) % 30 === 0) {
                option.medium = true;
              } else {
                option.small = true;
              }

              return (
                <div key={index} className={cx(['tic', option])} style={{ transform: `rotate(${index * 15}deg)` }} />
              );
            })}
            <div className={cx(['label', 'n'])}>N</div>
            <div className={cx(['label', 'e'])}>E</div>
            <div className={cx(['label', 's'])}>S</div>
            <div className={cx(['label', 'w'])}>W</div>
          </div>
          <div className={cx('arrowWrapper')} style={{ transform: `rotate(${values.yaw}deg)` }}>
            <img
              src={require('@/assets/images/attitude/left-arrow.png')}
              alt=""
              draggable="false"
              className={cx('arrow')}
            />
          </div>
        </div>
      </div>
      <table cellSpacing={0} className={cx('table')}>
        <thead>
          <tr>
            <th>Roll</th>
            <th>Pitch</th>
            <th>Yaw</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{Math.round(values.roll)}°</td>
            <td>{Math.round(values.pitch)}°</td>
            <td>{Math.round(values.yaw)}°</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Attitude;
